"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MagnifyContainerPortal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
// eslint-disable-next-line import/no-extraneous-dependencies
var react_dom_1 = require("react-dom");
var react_popper_1 = require("react-popper");
var MaginfyContainer_1 = require("./MaginfyContainer");
var useLazyRef_1 = require("./hooks/useLazyRef");
// import { styleToCssText } from 'src/utils';
var constants_1 = require("./constants");
exports.MagnifyContainerPortal = (0, react_1.forwardRef)(function (props, ref) {
  var _props$portalProps = props.portalProps,
    portalProps = _props$portalProps === void 0 ? {} : _props$portalProps,
    rest = __rest(props, ["portalProps"]);
  var className = portalProps.className,
    id = portalProps.id,
    style = portalProps.style,
    _portalProps$placemen = portalProps.placement,
    placement = _portalProps$placemen === void 0 ? constants_1.MagnifiedImagePosition.LEFT : _portalProps$placemen,
    strategy = portalProps.strategy,
    onFirstUpdate = portalProps.onFirstUpdate,
    dataTestId = portalProps.dataTestId,
    _portalProps$modifier = portalProps.modifiers,
    modifiers = _portalProps$modifier === void 0 ? [] : _portalProps$modifier,
    _portalProps$horizont = portalProps.horizontalOffset,
    horizontalOffset = _portalProps$horizont === void 0 ? 0 : _portalProps$horizont,
    _portalProps$vertical = portalProps.verticalOffset,
    verticalOffset = _portalProps$vertical === void 0 ? 0 : _portalProps$vertical;
  var _ref = (0, react_1.useState)(null),
    _ref2 = _slicedToArray(_ref, 2),
    popperElement = _ref2[0],
    setPopperElement = _ref2[1];
  var popper = (0, react_popper_1.usePopper)(ref.current, popperElement, {
    placement: placement,
    strategy: strategy,
    onFirstUpdate: onFirstUpdate,
    modifiers: [{
      name: 'offset',
      options: {
        offset: [verticalOffset, horizontalOffset]
      }
    }].concat(_toConsumableArray(modifiers))
  });
  var randId = (0, useLazyRef_1.useLazyRef)(function () {
    return Math.floor(Math.random() * 9999);
  });
  var portalRef = (0, useLazyRef_1.useLazyRef)(function () {
    return document.createElement('div');
  });
  var popperRef = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setPopperElement(node);
    }
  }, []);
  var el = portalRef.current;
  el.id = id || "".concat(constants_1.DEFAULT_PORTAL_ID, "-").concat(randId.current);
  // el.style.cssText = styleToCssText({ zIndex: 101, ...style });
  if (className) {
    el.className = className;
  }
  if (dataTestId) {
    el.setAttribute('data-test-id', dataTestId);
  }
  (0, react_1.useEffect)(function () {
    document.body.appendChild(el);
    return function () {
      document.body.removeChild(el);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)("div", Object.assign({
    ref: popperRef,
    style: Object.assign(Object.assign({
      zIndex: 101
    }, popper.styles.popper), style)
  }, popper.attributes.popper, {
    children: (0, jsx_runtime_1.jsx)(MaginfyContainer_1.MagnifyContainer, Object.assign({
      isPortalRendered: true
    }, rest), void 0)
  }), void 0), el);
});